import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import { IconActionSort16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './SortingButton.css';

export interface ISortingButtonProps {
  onClick: () => void;
  children?: string;
}

export const SortingButton = React.forwardRef((props: ISortingButtonProps, ref: React.Ref<HTMLButtonElement>) => {
  const { onClick, children } = props;

  return (
    <button
      ref={ref}
      className={styles['sort-button']}
      onClick={onClick}
      type="button"
      aria-label="Сортировка"
      aria-haspopup="listbox"
    >
      <span className={styles['sort-icon']}>
        <IconActionSort16 color="current_color" />
      </span>
      <UIText2 color="current_color" fontWeight={'normal'} whiteSpace={'nowrap'}>
        {children}
      </UIText2>
    </button>
  );
});

SortingButton.displayName = 'SortingButton';
